const modalSize = {
	DEFAULT: "default",
	MEDIUM: "medium",
	FULLSCREEN: "fullscreen",
};

export default modalSize;
